import { backupAPI } from '../services/api';

/**
 * Create a backup and immediately trigger a browser download.
 * The browser will prompt the user to choose where to save the file.
 */
export default async function createAndDownloadBackup(type = 'Manual') {
  // Step 1: Create the backup on the server
  const result = await backupAPI.create({ type });
  if (!result || !result.id) throw new Error('Backup was not created');

  // Step 2: Download the encrypted .ledgerpro backup file
  const blob = await backupAPI.download(result.id);
  const filename = result.filename || `ledgerpro-backup-${Date.now()}.ledgerpro`;

  // Step 3: Trigger browser download (prompts user for save location)
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  // Clean up the object URL after a short delay
  setTimeout(() => URL.revokeObjectURL(url), 5000);

  return result;
}
